import React from "react";
import { TextInput } from "@mantine/core";

interface TagNameInputProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any;
}

const TagNameInput: React.FC<TagNameInputProps> = ({ form }) => (
  <TextInput
    label="Tag Name"
    placeholder="Add a name"
    description="e.g. Teams, regions or roles"
    required
    {...form.getInputProps("name")}
  />
);

export default TagNameInput;
